import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {CardHolder, CardModel, IPlatformToolCard, MagicLinkModel} from '@shared/models/platform-tool-models';
import {PlatformQueryResponse} from '@shared/models/platform-query/platform-query';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {FlexSheetService} from '@features/spreadsheet/services/flex-sheet.service';
import {CommandService} from '@core/services/command.service';
import {DialogService} from '@shared/services/dialog-service';
import {SnackBarService} from '@core/services/snack-bar.service';


import { FlatTreeControl } from "@angular/cdk/tree";
import { MatTreeFlatDataSource, MatTreeFlattener }
  from "@angular/material/tree";
import {StepByStepWorkbookGuideService} from '@features/spreadsheet/services/step-by-step-workbook-guide.service';


/** Flat node with expandable and level information */
interface GuideFlatNode {
  expandable: boolean;
  title: string;
  level: number;
}
@Component({
    standalone: false,
    selector: 'app-step-by-step-workbook-guide-card',
  templateUrl: './step-by-step-workbook-guide-card.component.html',
  styleUrls: ['./step-by-step-workbook-guide-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StepByStepWorkbookGuideCardComponent implements OnInit, AfterViewInit, IPlatformToolCard {
  card: CardModel;
  cardHolder: CardHolder;
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  queryResponse: PlatformQueryResponse;
  isOneLevelVisible: boolean;
  isTwoLevelVisible: boolean;
  isThreeLevelVisible: boolean;
  guideModel = null;
  constructor(public flexSheetService: FlexSheetService,
              private commandService: CommandService,
              private dialogService: DialogService,
              private stepByStepWorkbookGuideService: StepByStepWorkbookGuideService,
              private snackBarService: SnackBarService) {
  }

  ngOnInit(): void {
    this.isOneLevelVisible = true;
    this.isTwoLevelVisible = true;
    this.isThreeLevelVisible = true;
  }



  ngAfterViewInit(): void {
   this.guideModel =  this.card.fieldValues.GuideModel;
    this.dataSource.data = this.guideModel.items;
  }

  onLoad() {
  }


  private _transformer = (node: any, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      title: node.title,
      level: level,
    };
  }

  treeControl = new FlatTreeControl<GuideFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource = new MatTreeFlatDataSource(
    this.treeControl, this.treeFlattener);


  hasChild = (_: number,
              node: GuideFlatNode) => node.expandable

  toggleOneLevel() {
    this.isOneLevelVisible = !this.isOneLevelVisible;
  }
  toggleTwoLevel() {
    this.isTwoLevelVisible = !this.isTwoLevelVisible;
  }
  toggleThreeLevel() {
    this.isThreeLevelVisible = !this.isThreeLevelVisible;
  }

}
